import { render } from "./EmptyLayout.vue?vue&type=template&id=cb9c4372"
const script = {}

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__